import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import apiRequest from '../../../../../utils/apiRequest';
import { COURIER_ORDERS } from '../../../../../apis';
import { handleChangeDataCourierOrders } from '../../../../../redux/actions/pages/courier/orders';
import CardOrder from './cards/cardOrder';
import OrderEmpty from '../../../../../styles/images/svg/order-empty.svg';



const CourierOrders = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { isMobile } = useSelector(state => state.general);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { courierToken } = useSelector(state => state.courierLogin);
	const { orders, selectedTab } = useSelector(state => state.courierOrders);

	const pendingOrders = orders && orders.filter(order => order.status === "pending" || order.status === 'shipped');
	const deliveredOrders = orders && orders.filter(order => order.status === 'delivered');
	
	const showOrders = orders && orders.filter(order => order.status === selectedTab || order.status === (selectedTab === 'pending' ? 'shipped' : selectedTab));

	

	useEffect(() => {
		dispatch(handleChangeDataCourierOrders('orders', []));
        apiOrders();
    }, []);

    const handleChangeTab = (status) => {
    	dispatch(handleChangeDataCourierOrders('selectedTab', status));
    };


	const apiOrders = () => {
		if(! isBackdropLoading) {
			apiRequest({
			    dispatch,
			    endpoint: COURIER_ORDERS,
			    method: 'get',
			    token: courierToken, 
			    onSuccess: (res) => {
			      	dispatch(handleChangeDataCourierOrders('orders', res.orders));

			      	let procceingOrders = res.orders.filter(order => order.status === "pending" || order.status === 'shipped');
			    	if(procceingOrders.length === 0)
			    		dispatch(handleChangeDataCourierOrders('selectedTab', 'delivered'));
			    },
		  	});
		}
	};

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

    return (
    	<>

    	{isMobile ?
    	<div className="lg:rounded-medium relative styles-Frame-profile-content mb-4 bg-neutral-000">
    		<div className="flex justify-between items-center lg:py-4 px-4">
    			<div className="break-words py-3 styles-ProfileCard-title-mobileHeader">
    				<div className="flex items-center grow">
    					<div className="flex shrink-0 ml-2 cursor-pointer" onClick={() => navigate(-1)} >
    						<ArrowForwardIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
    					</div>
    					<p className="grow text-h5 text-neutral-900 mb-0">
    						<span className="relative">تاریخچه سفارشات</span>
    					</p>
    				</div>
    			</div>
    			<Link className="styles_Link__RMyqc py-3 styles-ProfileCard-title-mobileHeader" >
					<div className="flex">
						<svg style={{width: '24px', height: '24px'}}>
							<use xlinkHref="#registerationSignOut"></use>
						</svg>
					</div>
				</Link>
    		</div>
    	</div>
    	:''}


    	<div className="lg:rounded-medium relative styles-Frame-profile-content mb-4 bg-neutral-000">

			<div className="flex justify-between items-center lg:py-4 px-4">
				{! isMobile ?
				<div className="break-words py-3">
					<div className="flex items-center grow">
						<p className="grow text-h5 text-neutral-900 mb-0">
							<span className="relative">تاریخچه سفارشات</span>
						</p>
					</div>
				</div>
				:''}
				{/*<div className="w-full lg:w-unset">
					<div className="hidden lg:flex items-center justify-center text-neutral-700">
						<div className="flex cursor-pointer" >
							<SearchIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
						</div>
					</div>
					<div className="flex w-full lg:hidden items-center justify-center text-neutral-700 mb-2">
						<label className="FormComponentFrame-FormComponentFrame w-full FormComponentFrame-FormComponentFrame-normal">
							<div className="FormComponentFrame-FormComponentFrame-input-container px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 Input-InputWrapper-d">
								<div className="flex mr-2">
									<SearchIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
								</div>
								<div className="grow text-body-3">
									<input placeholder="جستجو در سفارش‌ها" className="px-2 TextField-TextField-input text-subtitle w-full TextField-TextField TextField-TextField-secondary-w text-subtitle w-full py-5 lg:py-2 rounded-medium" />
								</div>
								{!isMobile ?
								<div className="flex cursor-pointer" >
									<CancelIcon sx={{fontSize: '24px'}} />
								</div>
								:''}
							</div>
						</label>
					</div>
				</div>*/}
			</div>

			<div>
				<ul className="flex relative hide-scrollbar border-complete-b-200 whitespace-nowrap overflow-x-auto" >
					<li onClick={() => handleChangeTab('pending')} className={`relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 ${selectedTab === 'pending' ? 'text-primary-500 text-subtitle-strong' : 'text-subtitle text-neutral-500'} cursor-pointer`} >
						<div className="flex items-center">
							<div className="text-subtitle">جاری</div>
							<div className={`px-1 text-center flex items-center justify-center text-body2-strong text-neutral-000 rounded-small mr-1 ${selectedTab === 'pending' ? 'bg-primary-500' : 'bg-neutral-400'} OrdersTabs-ordersTabs-numberBadge`}>{pendingOrders && toPersianDigits(pendingOrders.length)}</div>
						</div>
						<div className={`absolute bottom-0 ${selectedTab === 'pending' ? '' : 'opacity-0'} styles-Tab-border`}></div>
					</li>
					<li onClick={() => handleChangeTab('delivered')} className={`relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 ${selectedTab === 'delivered' ? 'text-primary-500 text-subtitle-strong' : 'text-subtitle text-neutral-500'} cursor-pointer`} >
						<div className="flex items-center">
							<div className="text-subtitle">تحویل شده</div>
							<div className={`px-1 text-center flex items-center justify-center text-body2-strong text-neutral-000 rounded-small mr-1 ${selectedTab === 'delivered' ? 'bg-primary-500' : 'bg-neutral-400'} OrdersTabs-ordersTabs-numberBadge`}>{deliveredOrders && toPersianDigits(deliveredOrders.length)}</div>
						</div>
						<div className={`absolute bottom-0 ${selectedTab === 'delivered' ? '' : 'opacity-0'} styles-Tab-border`}></div>
					</li>
					{/*<li onClick={() => handleChangeTab('canceled')} className={`relative px-4 py-2 flex flex-row items-center grow justify-center lg:grow-0 ${selectedTab === 'canceled' ? 'text-primary-500 text-subtitle-strong' : 'text-subtitle text-neutral-500'} cursor-pointer`} >
						<div className="flex items-center">
							<div className="text-subtitle">لغو شده</div>
							<div className={`px-1 text-center flex items-center justify-center text-body2-strong text-neutral-000 rounded-small mr-1 ${selectedTab === 'canceled' ? 'bg-primary-500' : 'bg-neutral-400'} OrdersTabs-ordersTabs-numberBadge`}>{canceledOrders && toPersianDigits(canceledOrders.length)}</div>
						</div>
						<div className={`absolute bottom-0 ${selectedTab === 'canceled' ? '' : 'opacity-0'} styles-Tab-border`}></div>
					</li>*/}
				</ul>
				<ul className="p-5 lg:p-4">
					<li>
						{ showOrders.length > 0 ?
							<div className="flex flex-col lg:gap-y-4">
								{
									showOrders.map((order, key) => (
										<CardOrder key={`card-order-${key}`} data={order} showBorderBottom={(key + 1) < showOrders.length} />
									))
								}
							</div>
						:
							<div class="bg-neutral-000 flex flex-col items-center justify-center py-20">
								<div style={{width: '180px', height: '135px', lineHeight: '0'}}>
									<img class="w-full inline-block" src={OrderEmpty} width="180" height="135" alt="empty" title="" style={{objectFit: 'contain'}} />
								</div>
								<div class="text-body-1 text-neutral-900 mt-3">سفارشی برای شما وجود ندارد
								</div>
							</div>
						}
					</li>
				</ul>
			</div>
		</div>



		</>

    );
}

export default CourierOrders;